module.exports = __webpack_public_path__ + "media/images/mobile/abouts/1-308fcd51714de1b4c735715e34a87999.jpg";